import Vue, { CreateElement, Ref, ref } from 'vue';
import { ImagesSliderPhoto, ImagesSliderVideo } from '@ve/components/images-slider/common/types';
import ImagesSliderHotel from '@ve/components/hotel/images-slider-hotel/desktop/ImagesSliderHotel.vue';
import HotelPageGalleryStore, { NAMESPACE as HOTEL_PAGE_GALLERY_STORE } from '@ve/pages/hotel/store/HotelPageGalleryStore';
import HotelTrackingService from '@ve/pages/hotel/analytics/yandexAnalytics/hotelTrackingService';

import getStore from '@ve/services/getStore/getStore';
import initHotelPageFullscreenGallery from './initHotelPageFullscreenGallery';

export default ({
                    el, images, videos, video, isVisibleThumbs = true,
                }: {
    el: string;
    images: ImagesSliderPhoto[];
    videos: ImagesSliderVideo[];
    video: ImagesSliderVideo,
    isVisibleThumbs: boolean,
}) => {
    const hotelTrackingService = new HotelTrackingService();
    const store = getStore();
    store.registerModule(HOTEL_PAGE_GALLERY_STORE, HotelPageGalleryStore);
    const isFullScreenSlider = ref(false);
    const selectedIndex = ref(0);
    let componentInstance: Vue | Record<string, any>;
    new Vue({
        name: 'images-slider-hotel',
        render(h: CreateElement) {
            return h(ImagesSliderHotel, {
                props: {
                    images,
                    videos,
                    video,
                    isVisibleThumbs,
                },
                on: {
                    openFullscreenSlider: (index: number): void => {
                        selectedIndex.value = index;
                        const fullScreenGalleryElement = document.getElementsByClassName('fullscreen-gallery')[0];

                        if (!fullScreenGalleryElement) {
                            const elementForMounting = document.createElement('div');
                            elementForMounting.className = 'fullscreen-gallery';
                            document.getElementsByTagName('body')[0].appendChild(elementForMounting);
                        }

                        if (!componentInstance) {
                            componentInstance = initHotelPageFullscreenGallery({
                                el: '.fullscreen-gallery',
                                images,
                                videos,
                                video,
                                isVisibleThumbs,
                                parentSelectedIndex: selectedIndex,
                                isFullScreenSlider,
                                store,
                            });
                            isFullScreenSlider.value = true;
                            return;
                        }

                        isFullScreenSlider.value = true;
                    },
                    'slider-hotel-click': () => {
                        const paramsForHotelPageGalleryAnalytic = store.getters[`${HOTEL_PAGE_GALLERY_STORE}/paramsForHotelPageGalleryAnalytic`];
                        hotelTrackingService.hotelPageGalleryClick(paramsForHotelPageGalleryAnalytic);
                    },
                },
            });
        },
        store,
    }).$mount(el);
};